/* global angular*/
import './style.less';

export default function() {
  'ngInject';

  const vm = this;

  vm.$onChanges = activate;

  vm.sortableOptions = {
    connectWith: '.connectList',
    update: () => {
      vm.form.$setDirty();
    }
  };

  vm.questionTypeDict = {
    radio: { key: 'radio', name: 'Ratings', description: 'User will answer these questions on a scale of 1 to 5.' },
    checkbox: {
      key: 'checkbox',
      name: 'Multiple Choice',
      description: 'User will answer these questions by choosing one answer from the list.'
    },
    input: {
      key: 'input',
      name: 'Single Line Responses',
      description: 'User will answer these questions in a small input field.'
    },
    text_area: { key: 'text_area', name: 'Paragraph Responses', description: 'Paragraph Responses' }
  };

  const defaultOrder = ['radio', 'checkbox', 'input', 'text_area'];

  function activate() {
    vm.ngModel = vm.ngModel || defaultOrder;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questionTypeOrder/controller.js